// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","tabItem":"_7cEILnw7bWr2L3b-pJpM9","highlighted":"T2kcBUoqhqbMTDO8GpyVG"};